import React from "react";

export default function Button({ variant, children, ...props }) {
  return (
    <div {...props} className={`button button-${variant}`}>
      {children}
    </div>
  );
}
